import { render, staticRenderFns } from "./bottomBar.vue?vue&type=template&id=62572cf0&scoped=true"
import script from "./bottomBar.vue?vue&type=script&lang=js"
export * from "./bottomBar.vue?vue&type=script&lang=js"
import style0 from "./bottomBar.vue?vue&type=style&index=0&id=62572cf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.27_babel-core@6.26.3_css-loader@6.11.0_webpack@5.92._4ybukp33xmar2t4t23nvjqqetu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62572cf0",
  null
  
)

export default component.exports